import { useTranslation } from 'react-i18next'

import { useBoundStore } from '../../store/store'
import classNames from '../../utils/classNames'
import Icon from '../icon'

const ThemeSwitch = () => {
  const theme = useBoundStore(state => state.common.theme)
  const setTheme = useBoundStore(state => state.common.setTheme)
  const { t } = useTranslation('common')

  return (
    <button
      className={classNames(
        'w-60 h-[50px] block bg-secondary relative transition-all duration-[0.2s] ease-[ease-in-out]',
        'mt-[25px] mb-0 mx-auto p-[5px] rounded-[5px] xl:ml-[15px] xl:mr-0 xl:mt-[25px] xl:mb-0',
      )}
      onClick={() => {
        if (theme === 'light') {
          setTheme('dark')
          localStorage.setItem('theme', 'dark')
          document.body.classList.remove('theme-light')
          !document.body.classList.contains('theme-dark') &&
            document.body.classList.add('theme-dark')
        } else {
          setTheme('light')
          localStorage.setItem('theme', 'light')
          document.body.classList.remove('theme-dark')
          !document.body.classList.contains('theme-light') &&
            document.body.classList.add('theme-light')
        }
      }}>
      <div
        className={classNames(
          'absolute w-[calc(50%_-_5px)] h-10 transition-all duration-[0.2s] ease-[ease-in-out]',
          'rounded-[5px] top-[5px] bg-[#eaecf3] left-[calc(50%)] dark:bg-[#0e091e] dark:left-[5px]',
        )}
      />
      <div
        className={classNames(
          'w-6/12 absolute leading-10 left-[5px] flex items-center justify-center',
          'text-sm z-[1] transition-all duration-[0.2s] ease-[ease-in-out] top-[5px]',
          theme === 'dark' ? 'text-txt' : 'text-[#888]',
        )}>
        <Icon
          className="fill-[#888] transition-all duration-[0.2s] ease-[ease-in-out] mr-[7px]"
          id="moon"
          width="16"
          height="17"
        />
        {t('dark')}
      </div>
      <div
        style={{ right: 5 }}
        className={classNames(
          'w-6/12 absolute leading-10 right-[5px] flex items-center justify-center',
          'text-sm z-[1] transition-all duration-[0.2s] ease-[ease-in-out] top-[5px]',
          theme === 'light' ? 'text-txt' : 'text-[#888]',
        )}>
        <Icon
          className="fill-[#888] transition-all duration-[0.2s] ease-[ease-in-out] mr-[7px]"
          id="sun"
          width="17"
          height="17"
        />
        {t('light')}
      </div>
    </button>
  )
}

export default ThemeSwitch
